




















































import { Vue, Component, Prop } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent";
import SectionUpdateListItem from "@/components/vcponlineok/staff-user/section-update-list-item.vue";
import util from "@/lib/util";
import {
  VcClaimChangeDto,
  IVcClaimChangeDto,
  IVcSubmissionDtoOfVcClaimUpdateRequestDto,
  ResponseToApplicantRequestDto,
  ResponseToClaimSubmissionDto
} from "@/asdcom/apiproxy/apiproxy.dto";
import { EventEmitter } from "events";
import ClaimViewBaseComponent from "@/views/vcponlineok/staff-user/claim-view/ClaimViewBaseComponent";

@Component({
  components: {
    SectionUpdateListItem
  }
})
export default class UpdateRequest extends ClaimViewBaseComponent {
  loading: boolean = false;
  approvalStatuses: any[] = [];
  inputModel = new ResponseToClaimSubmissionDto();

  @Prop({ default: () => {} }) viewModel: IVcSubmissionDtoOfVcClaimUpdateRequestDto;

  get requestApprovalStatuses() {
    if (!!this.viewModel.validWorkItemStatuses) {
      this.viewModel.validWorkItemStatuses.forEach((i: number) => {
        this.approvalStatuses.push(util.abp.constant.submissionStatus.values[i])
      })
      return this.approvalStatuses
    }
  }

  async onSave() {
    this.inputModel.vcSubmissionId = this.viewModel.id;
    this.ValidateAll().then((isValid: boolean) => {
      if (isValid) {
        this.$appsvs.vcpOnlineOkStaff.submitResponseToClaimSubmission(this.inputModel)
        .then((res: any) => {
          this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
          this.$emit("onClose");
        })
      } 
    })
  }
}
